export default "__VITE_ASSET__B0I4Yz1Y__"